import App, {Container} from 'next/app'
import StoreProvider from 'providers/StoreProvider'
import RouterProvider from 'providers/RouterProvider'
import {ThemeProvider, GlobalStyle as ThemeGlobalStyle, darkTheme} from '@binance/uikit'
import GlobalStyle from 'components/GlobalStyle'

class MainApp extends App {
  render () {
    const {
      router,
      Component,
      pageProps: {initialActions, ...otherProps}
    } = this.props

    return (
      <ThemeProvider theme={darkTheme}>
        <Container>
          <GlobalStyle />
          <ThemeGlobalStyle />
          <RouterProvider router={router}>
            <StoreProvider initialActions={initialActions}>
              <Component {...otherProps} />
            </StoreProvider>
          </RouterProvider>
        </Container>
      </ThemeProvider>
    )
  }
}

export default MainApp
